import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';

const ModalButton = ({ onModalClose, onStart }) => {
  return (
    <div className="test-modal-button-wrapper">
      <Button className="test-modal-button-link" type="link" onClick={onModalClose}>Go to Talent Portal</Button>
      <Button className="test-modal-button" type="primary" onClick={onStart}>Start Survey Now</Button>
    </div>
  );
};

ModalButton.propTypes = {
  onModalClose: PropTypes.func,
  onStart: PropTypes.func
};

export default ModalButton;
